export default __webpack_public_path__ + "img/metering.b0d4a03e.png";